import {
  FaBook,
  FaBoxOpen,
  FaChartBar,
  FaCog,
  FaDesktop,
  FaFileInvoiceDollar,
  FaFolderOpen,
  FaHome,
  FaKey,
  FaQuestionCircle,
  FaSearch,
  FaShieldAlt,
  FaStore,
  FaTags,
  FaTools,
  FaUsers,
} from "react-icons/fa";
import { HiOutlineStatusOnline } from "react-icons/hi";

const UI_ICON_MAP = {
  home: FaHome,
  shield: FaShieldAlt,
  "folder-open": FaFolderOpen,
  key: FaKey,
  tools: FaTools,
  "chart-bar": FaChartBar,
  tags: FaTags,
  book: FaBook,
  "box-open": FaBoxOpen,
  "file-invoice-dollar": FaFileInvoiceDollar,
  desktop: FaDesktop,
  search: FaSearch,
  store: FaStore,
  cog: FaCog,
  users: FaUsers,
  status: HiOutlineStatusOnline,
};

export const getUiIcon = (iconName) => UI_ICON_MAP[iconName] || FaQuestionCircle;
